import { Tooltip,Label } from '../../../../../CommonComponents';
import './OrderDetail.scss'

const OrderDetail = (props: any) => {
  return <div className="borderCard pendingApprovalOrder">
    <div>
      <Label data-attribute="OrderDetail_Default_Label">Current Branch</Label>
      <Tooltip content={props.orderByIdValue?.costCenter} data-attribute="OrderDetail_Default_Tooltip">
        <div className="content" >{props.orderByIdValue?.costCenter || '-'}</div>
      </Tooltip>
    </div>

    <div>
      <Label data-attribute="OrderDetail_Default_Label_2">Qty</Label>
      <Tooltip content={props.quantity.toString()} data-attribute="OrderDetail_Default_Tooltip_2">
        <div className="content" >{props.quantity || '-'}</div>
      </Tooltip>
    </div>
    <div>
      <Label data-attribute="OrderDetail_Default_Label_3">Requested By</Label>
      <Tooltip content={props.orderByIdValue?.requestedBy != " " ? props.orderByIdValue?.requestedBy : '-'} data-attribute="OrderDetail_Default_Tooltip_3">
        <div className="content" >{props.orderByIdValue?.requestedBy != " " ? props.orderByIdValue?.requestedBy : '-'}</div>
      </Tooltip>
    </div> 
    <div>
      <Label data-attribute="OrderDetail_Default_Label_4">Assigned To</Label>
      <Tooltip content={props.orderByIdValue?.assignedTo != " " ? props.orderByIdValue?.assignedTo : "-"} data-attribute="OrderDetail_Default_Tooltip_4">
        <div className="content">{props.orderByIdValue?.assignedTo != " " ? props.orderByIdValue?.assignedTo : "-"}</div>
      </Tooltip>
    </div>
    <div>
      <Label data-attribute="OrderDetail_Default_Label_5">Capital/Lease Expenditures (M & A)</Label>
      <Tooltip content={props.orderByIdValue?.isMandAFlag} data-attribute="OrderDetail_Default_Tooltip_5">
        <div className="content">{props.orderByIdValue?.isMandAFlag ? "Yes" : "No"}</div>
      </Tooltip>
    </div>
    
    <div>
      {!props?.orderByIdValue?.isBulkOrder ?
        <>
          <Label data-attribute="OrderDetail_Default_Label_6">Pre-Authorized</Label>
          <Tooltip content={props.orderByIdValue?.isApprovalOverride} data-attribute="OrderDetail_Default_Tooltip_6">
            <div className="content">{props.orderByIdValue?.isApprovalOverride ? "Yes" : "No"}</div>
          </Tooltip>
        </>
        : null}
    </div>
    <div className='order-total'>
      <Label data-attribute="OrderDetail_Default_Label_7">Order Total</Label>
      <Tooltip content={'$' + (props.getFormattedValue(Number(props.orderByIdValue?.grandTotal || 0)))} data-attribute="OrderDetail_Default_Tooltip_7">
        <div className="content orderTotal">${(props.getFormattedValue(Number(props.orderByIdValue?.grandTotal || 0)))}</div>
      </Tooltip>
    </div>
  </div>
}

export default OrderDetail;